export const labelStyles = 'mt-[16px] mb-[6px] block font-extrabold text-[12px]/[14px]';
export const requiredStyles = 'text-[#F02D3A] text-[10px]/[14px] align-top';
export const inputStyles =
  'border p-[10px] text-[16px]/[20px] border-[1px] border-gray-300 rounded-[4px] focus:border-gray-400 focus:outline-none';
export const sectionStyles = 'mt-[30px] text-[#949599] text-[18px/22px]';

// Custom styles for react-select to match input styles
export const selectStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    borderColor: state.isFocused ? '#9ca3af' : '#d1d5db',
    borderWidth: '1px',
    borderRadius: '4px',
    padding: '2px 4px',
    minHeight: '42px',
    fontSize: '16px',
    lineHeight: '20px',
    boxShadow: 'none',
    backgroundColor: 'white',
    '&:hover': {
      borderColor: '#9ca3af',
    },
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    padding: '6px 8px',
  }),
  input: (provided: any) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
  menu: (provided: any) => ({
    ...provided,
    borderColor: '#d1d5db',
    borderWidth: '1px',
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#e5e7eb' : state.isFocused ? '#f3f4f6' : 'white',
    color: '#111827',
  }),
};
